// extracted by mini-css-extract-plugin
module.exports = {"Burger":"BurgerNav_Burger__15Qpv","BurgerRow":"BurgerNav_BurgerRow__2glK9"};